import { Field } from "formik";

import { FormFieldWrapper } from "../../../../organisms/form-field-wrapper";
import { FormikFormInputText } from "../../form-input-text";

interface IProps {
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormFieldFirstNameFreeText: React.FC<IProps> = ({
  id = "firstName",
  label = "Child's first name",
  placeholder = "Enter first name",
  required = true,
}) => (
  <FormFieldWrapper label={label} required={required} name={id}>
    <Field name={id} component={FormikFormInputText} placeholder={placeholder} />
  </FormFieldWrapper>
);
